module.exports = __webpack_public_path__ + "static/media/chart-ethereum.f84ddda1.jpg";